import { Product } from './types';

export const lifeProducts: Product[] = [
  {
    id: 'MA1',
    numericId: 401,
    name: 'MA1',
    description: '变频节能，远程控制，空气净化功能',
    price: '12,999₽',
    image: '/images/life/scene/MA1/MA1_main.jpg',
    cardImage: '/images/life/MA1.png',
    gallery: [
      {
        src: 'https://via.placeholder.com/800x600/333/fff?text=智能空调-正面',
        alt: '智能空调-正面视图',
        caption: '简约现代设计，隐藏式显示屏'
      },
      {
        src: 'https://via.placeholder.com/800x600/333/fff?text=智能空调-侧面',
        alt: '智能空调-侧面视图',
        caption: '超薄机身设计，完美融入家居环境'
      },
      {
        src: 'https://via.placeholder.com/800x600/333/fff?text=智能空调-内部',
        alt: '智能空调-内部结构',
        caption: '高效变频压缩机，节能环保'
      },
      {
        src: 'https://via.placeholder.com/800x600/333/fff?text=智能空调-遥控器',
        alt: '智能空调-遥控器',
        caption: 'E-ink显示屏遥控器，低功耗长续航'
      }
    ],
    features: [
      '全直流变频技术，高效节能',
      '智能温控系统，精准控温至0.1℃',
      '内置空气净化功能，过滤PM2.5',
      '智能风向调节，避免直吹',
      '静音设计，低至18dB运行噪音',
      '远程控制，随时调节家中温度',
      '自清洁功能，防止细菌滋生'
    ],
    specifications: {
      '型号': 'ES-AC001',
      '尺寸': '900 × 300 × 195 毫米',
      '制冷量': '3500W',
      '制热量': '4200W',
      '能效等级': '一级能效',
      '适用面积': '15-25平方米',
      '噪音': '18-38dB',
      '制冷剂': 'R32环保冷媒',
      '控制方式': '触控/遥控/APP远程控制',
      '特殊功能': '空气净化、自清洁、除湿',
      '颜色': '象牙白',
      '保修': '5年压缩机，3年整机保修'
    }
  },
  {
    id: 'MD1',
    numericId: 402,
    name: 'MD1',
    description: '自动感应，定时控制，静音电机',
    price: '6,999₽',
    image: '/images/life/scene/MD1/MD1_main.jpg',
    cardImage: '/images/life/MD1.png'
  },
  {
    id: 'MS1',
    numericId: 403,
    name: 'MS1',
    description: '多种解锁方式，防盗报警，远程控制',
    price: '4,999₽',
    image: '/images/life/scene/MS1/MS1_main.jpg',
    cardImage: '/images/life/MS1.png'
  },
  {
    id: 'BD1',
    numericId: 404,
    name: 'BD1',
    description: '激光导航，深度清洁，自动回充',
    price: '5,999₽',
    image: '/images/life/scene/BD1/BD1_main.jpg',
    cardImage: '/images/life/BD1.png'
  },
  {
    id: 'BS1',
    numericId: 405,
    name: 'BS1',
    description: '激光导航，深度清洁，自动回充',
    price: '2,499₽',
    image: '/images/life/scene/BS1/BS1_main.jpg',
    cardImage: '/images/life/BS1.png'
  },
  {
    id: 'BS2',
    numericId: 406,
    name: 'BS2',
    description: '激光导航，深度清洁，自动回充',
    price: '3,399₽',
    image: '/images/life/scene/BS2/BS2_main.jpg',
    cardImage: '/images/life/BS2.png'
  },
  {
    id: 'BC1',
    numericId: 407,
    name: 'BC1',
    description: '激光导航，深度清洁，自动回充',
    price: '2,499₽',
    image: '/images/life/scene/BC1/BC1_main.jpg',
    cardImage: '/images/life/BC1.png'
  },
  {
    id: 'BT1',
    numericId: 408,
    name: 'BT1',
    description: '激光导航，深度清洁，自动回充',
    price: '699₽',
    image: '/images/life/scene/BT1/BT1_main.jpg',
    cardImage: '/images/life/BT1.png'
  },
  {
    id: 'RI1',
    numericId: 409,
    name: 'RI1',
    description: '激光导航，深度清洁，自动回充',
    price: '3,499₽',
    image: '/images/life/scene/RI1/RI1_main.jpg',
    cardImage: '/images/life/RI1.png'
  },
  {
    id: 'RC1',
    numericId: 410,
    name: 'RC1',
    description: '激光导航，深度清洁，自动回充',
    price: '3,499₽',
    image: '/images/life/scene/RC1/RC1_main.jpg',
    cardImage: '/images/life/RC1.png'
  },
  {
    id: 'RS1',
    numericId: 411,
    name: 'RS1',
    description: '激光导航，深度清洁，自动回充',
    price: '3,499₽',
    image: '/images/life/scene/RS1/RS1_main.jpg',
    cardImage: '/images/life/RS1.png'
  },
  {
    id: 'Life-S1',
    numericId: 412,
    name: 'S1',
    description: '激光导航，深度清洁，自动回充',
    price: '2,999₽',
    image: '/images/life/scene/S1/S1_main.jpg',
    cardImage: '/images/life/S1.png'
  },
  {
    id: 'E1',
    numericId: 413,
    name: 'E1',
    description: '激光导航，深度清洁，自动回充',
    price: '3,699₽',
    image: '/images/life/scene/E1/E1_main.jpg',
    cardImage: '/images/life/E1.png'
  },
  {
    id: 'P1',
    numericId: 414,
    name: 'P1',
    description: '激光导航，深度清洁，自动回充',
    price: '2,999₽',
    image: '/images/life/scene/P1/P1_main.jpg',
    cardImage: '/images/life/P1.png'
  },
  {
    id: 'Life-R1',
    numericId: 415,
    name: 'R1',
    description: '激光导航，深度清洁，自动回充',
    price: '2,499₽',
    image: '/images/life/scene/R1/R1_main.jpg',
    cardImage: '/images/life/R1.png'
  },
  {
    id: 'OI1',
    numericId: 416,
    name: 'OI1',
    description: '激光导航，深度清洁，自动回充',
    price: '3,499₽',
    image: '/images/life/scene/OI1/OI1_main.jpg',
    cardImage: '/images/life/OI1.png'
  }
]; 